/* eslint-disable */
<template>
  <v-container fluid>
    <v-card flat class="font">
      <v-card-title>
        My Refund List
        <v-spacer />
        <v-btn color="primary" @click="applyRefund">
          Apply For Student Refund
          <v-icon class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="refund"
          :items-per-page="5"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="elevation-0"
          item-key="reg_no"
          fixed-header
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.requestedRefundAmt`]="{ item }">
            <span>{{ item.requestedRefundAmt | currencyFormat }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span class="text-lowercase">
              <v-icon size="14" :color="statusColor[item.status.toLowerCase()]">
                mdi-radiobox-marked
              </v-icon>
              {{ statusWordings(item.status) }}
            </span>
          </template>
          <!--BEGIN Menu action-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :to="{
                    name: 'RefundCard',
                    params: { code: encryptedViewParam(item.no) },
                  }"
                >
                  <v-icon color="primary">visibility</v-icon> View
                </v-list-item>
                <v-list-item
                  @click="sendForApproval({ requestNo: item.no })"
                  v-if="item.status === 'Open'"
                >
                  <v-icon color="primary">schedule_send</v-icon> Send Approval
                  Request
                </v-list-item>
                <v-list-item
                  @click="cancelApprovalRequest({ requestNo: item.no })"
                  v-if="item.status === 'Pending'"
                >
                  <v-icon color="deep-orange">cancel_schedule_send</v-icon>
                  Cancel Approval Request
                </v-list-item>
                <v-divider />
                <v-list-item
                  v-if="item.status === 'Open'"
                  @click="deleteRefund(item)"
                >
                  <v-icon color="deep-orange darken-4">delete</v-icon> Delete
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END Menu action-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import status from "@/packages/applications/status.js";
import { helper } from "../../dashboard/utils";
export default {
  name: "RefundListComponent",
  data: () => ({
    headers: [
      { text: "#S/N", sortable: true, value: "ID" },
      { text: "Code", sortable: true, value: "no" },
      { text: "profile ID", sortable: false, value: "profileID" },
      { text: "student No", sortable: false, value: "studentNo" },
      { text: "Requested Amount (KES)", value: "requestedRefundAmt" },
      { text: "Status", value: "status", sortable: true },
      { text: "Actions", value: "action", sortable: false },
    ],
    sortBy: "no",
    sortDesc: true,
  }),
  computed: {
    statusColor() {
      return status;
    },
    refund() {
      return this.$store.getters["Refund/refundGetter"]("refunds").sort(
        (a, b) => new Date(b.documentDate) - new Date(a.documentDate),
      );
    },
    studentBalance() {
      return this.$store.getters["Refund/refundGetter"]("studentBalance");
    },
  },
  methods: {
    deleteRefund(item) {
      this.$confirm.show({
        title: `Delete refund ${item.no} ?`,
        text: "Are you sure you want to delete this refund,this action is irreversible",
        onConfirm: () => {
          this.$store.dispatch("Refund/deleteRefund", { ...item });
        },
      });
    },
    statusWordings(status) {
      if (status === "Released") {
        return "Approved";
      } else if (status === "Open") {
        return "Processing";
      } else {
        return status;
      }
    },
    encryptedPaymentParam(item) {
      return helper.encrypt(item);
    },
    encryptedViewParam(item) {
      return helper.encrypt(item);
    },
    sendForApproval(data) {
      this.$confirm.show({
        title: "Student Refund Approval Request",
        text: `Send Refund Request No. ${data.requestNo}.`,
        onConfirm: () => {
          this.$store.dispatch("Refund/sendStudentRequestForApproval", data);
        },
      });
    },
    cancelApprovalRequest(data) {
      this.$confirm.show({
        title: "Student Refund Approval Request Cancel",
        text: `Cancel Approval Request for Refund Request No. ${data.requestNo}.`,
        onConfirm: () => {
          this.$store.dispatch("Refund/cancelStudentApprovalRequest", data);
        },
      });
    },
    applyRefund() {
      console.log(this.studentBalance);
      if (this.studentBalance === 0) {
        this.$alert({
          title: "Insufficient Student Balance",
          text: `Sorry, you student balance is ${this.studentBalance}`,
        });
      } else {
        this.$router.replace({ name: "RefundCard" });
      }
    },
  },
};
</script>
<style>
@import url("../styles/styles.css");
</style>
